import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0897184f&"
import script from "./Edit.ts?vue&type=script&lang=js&"
export * from "./Edit.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports